import React, { useState } from "react";
import { Formik } from "formik";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import { ErrorMessage } from "formik";
import { AddTaskSchema } from "../../../common/Validation";
import Spin from "../../../common/Spin";
import { API, fileUpload } from "../../../../config";

const AddNewTaskModal = ({
  handleAddNewTask,
  businessId,
  addNewTask,
  setNewTask,
  handleTaskChange,
  newTaskCode,
  setFinalData,
  finalData,
  index
}) => {
  const [loading, setLoading] = useState(false);

  const [taskData, setTaskData] = useState();

  const handleFormSubmit = async (value) => {
    const formData = new FormData();
    formData.append("client_business_id", businessId);
    formData.append("code", value?.code);
    formData.append(
      "description",
      value?.description ? value?.description : ""
    );

    try {
      setLoading(true);
      const { data } = await fileUpload(`${API.TASKS_ADD}`, formData);
      setLoading(false);
      if (data) {
        toast.success(data?.message);
        handleAddNewTask();
        handleTaskChange();
        let temp = {
          label: data?.data?.code + (data?.data?.description ? ' (' + data?.data?.description + ')' : ''),
          value: data?.data?.id,
        };
        setNewTask(temp);
        if (setFinalData) {
          finalData[index].task_id = temp?.value;
          setFinalData(finalData);
        }
      }
      setTaskData(value);
      return data?.data;
    } catch (error) {
      if (error?.response?.data?.errors) {
        Object.keys(error?.response?.data?.errors).forEach((key) => {
          toast.error(error?.response?.data?.errors[key][0]);
        });
        setLoading(false);
      } else {
        toast.error(error?.message);
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Modal
        size="lg"
        show={addNewTask}
        onHide={handleAddNewTask}
        dialogClassName="modal-50w larg-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        className="business-section"
        centered
      >
        <Modal.Header className="mb-0" closeButton>
          Add New Task
        </Modal.Header>
        <Modal.Body>
          <Formik
            initialValues={{
              task_id: taskData?.task_id,
              code: newTaskCode ? newTaskCode : taskData?.code,
              description: taskData?.description,
            }}
            enableReinitialize
            onSubmit={handleFormSubmit}
            validateOnBlur={true}
            validateOnChange={true}
            validationSchema={AddTaskSchema}
          >
            {({
              values,
              setErrors,
              errors,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
            }) => {
              return (
                <>
                  {loading && <Spin />}
                  <form
                    onSubmit={handleSubmit}
                    noValidate
                    className="entry-section"
                  >
                    <div className="form-box">
                      <div className="form-group full-width">
                        <label>
                          <span className="required">*</span>Code
                        </label>
                        <input
                          type="text"
                          name="code"
                          value={values?.code ? values?.code : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                        />
                        <span
                          className="text-danger"
                          style={{ color: "red", fontSize: "20px" }}
                        >
                          <ErrorMessage name="code" />
                        </span>
                      </div>
                      <div className="form-group full-width">
                        <label>
                          <span className="required">*</span>Description
                        </label>
                        <textarea
                          type="text"
                          name="description"
                          value={values?.description ? values?.description : ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          autoComplete="off"
                          onKeyPress={(e) => {
                            e.which === 13 && e.preventDefault();
                          }}
                          style={{
                            borderRadius: "10px",
                            margin: "0 0 0px",
                            minHeight: "70px",
                          }}
                        />
                        <span
                          className="text-danger"
                          style={{ color: "red", fontSize: "20px" }}
                        >
                          <ErrorMessage name="description" />
                        </span>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <Button type="submit">Save</Button>
                      <Button
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => {
                          handleAddNewTask();
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </form>
                </>
              );
            }}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AddNewTaskModal;
